import React from 'react';
import { FaSearch } from 'react-icons/fa'; // Importing search icon

const SearchBar = ({ searchTerm, setSearchTerm, onSearch }) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSearch(); // Trigger search when Enter key is pressed
    }
  };

  return (
    <div className="relative w-48 md:w-64 lg:w-80 text-sm flex items-center bg-gray-100 rounded-md px-3 py-1">
      {/* Search Icon */}
      <FaSearch className="text-gray-300 mr-2" />
      <input
        type="text"
        placeholder="Search for venue, sport, activities"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyDown={handleKeyDown} // Handle Enter key press
        className="w-full bg-transparent outline-none text-gray-700"
      />
      {/* Search Button */}
      <button
        onClick={onSearch}
        className="text-blue-200 hover:text-blue-500 text-sm ml-2"
      >
        <FaSearch />
      </button>
    </div>
  );
};

export default SearchBar;
